import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography, Grid } from '@mui/material';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import get from 'lodash/get';

import Card from '../components/Card';

const UnAuthAccess = () => {
  const isLoading = useSelector((state) => get(state.ecosystems.ecosystem.loading, 'count', false));
  const { countData: counters } = useSelector((state) => state.ecosystems.ecosystem);

  return (
    <Card icon={ReportProblemOutlinedIcon} isLoading={isLoading} title="Unauthorized Access">
      <Grid container sx={{ flex: 1 }}>
        <Grid item xs={6}>
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Typography variant="body1" sx={{ fontSize: 34 }} data-testid="count-access-attempts">
              {/** TODO: Use correct value */}
              {counters?.['blocked.access']}
            </Typography>
            <Typography textAlign="center" sx={{ fontSize: 14, mt: 1 }}>
              Access Attempts
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={6} sx={{ borderLeft: '1px solid #EFF2F7' }}>
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Typography variant="body1" sx={{ fontSize: 34 }} data-testid="count-access-blocked">
              {counters?.['blocked.access']}
            </Typography>
            <Typography textAlign="center" sx={{ fontSize: 14, mt: 1 }}>
              Access Blocked
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Card>
  );
};

export default UnAuthAccess;
